import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CorporatesPage from './pages/CorporatesPage';
import LocationsPage from './pages/LocationsPage';
import UsersPage from './pages/UsersPage';
import FormTemplatesPage from './pages/FormTemplatesPage';
import FormSubmissionsPage from './pages/FormSubmissionsPage';
import ReportsPage from './pages/ReportsPage';
import SmsSettingsPage from './pages/SmsSettingsPage';

const AdminApp = () => {
    return (
        <AuthProvider>
            <Routes>
                <Route path="login" element={<LoginPage />} />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Navigate to="dashboard" replace />} />
                    <Route path="dashboard" element={<DashboardPage />} />
                    <Route path="corporates" element={<CorporatesPage />} />
                    <Route path="locations" element={<LocationsPage />} />
                    <Route path="users" element={<UsersPage />} />
                    <Route path="form-templates" element={<FormTemplatesPage />} />
                    <Route path="submissions" element={<FormSubmissionsPage />} />
                    <Route path="reports" element={<ReportsPage />} />
                    <Route path="sms-settings" element={<SmsSettingsPage />} />
                </Route>
                <Route path="*" element={<Navigate to="dashboard" replace />} />
            </Routes>
        </AuthProvider>
    );
};

export default AdminApp;
